import { INTERNAL_TOKEN_NAME } from "../state/constants";

// =================================
// Basic Environmental Detection ===
// =================================

export const isInternal = function () {
  return isLocal() || JSON.parse(sessionStorage.getItem(INTERNAL_TOKEN_NAME));
};

export const isLocal = function () {
  return window.location.hostname.includes("localhost");
};

export const isDev = function () {
  return (
    isLocal() ||
    window.location.hostname.includes(".t.") ||
    window.location.hostname.includes(".dev.mb")
  );
};

export function filterByEnvironment(route) {
  if (route.environments) {
    if (isLocal() && !route.environments.includes("local")) {
      return false;
    }
    if (isDev() && !route.environments.includes("dev")) {
      return false;
    }
    if (!isDev() && !route.environments.includes("prod")) {
      return false;
    }
  }
  return true;
}
